// NavItem for books
export var booksNavItem = {
  parent: {
    text: 'Books',
    href: 'books'
  },
  children: [{
    text: 'Rent/Buy',
    href: 'books'
  }, {
    text: 'Read',
    href: 'etextbooks'
  }, {
    text: 'Return',
    href: 'returnbooks'
  }, {
    text: 'Sell',
    href: 'sell-textbooks'
  }]
}; // NavItem for study

export var studyNavItem = {
  parent: {
    text: 'Study',
    href: 'study'
  },
  children: [{
    parent: {
      text: 'Tasks'
    },
    children: [{
      text: 'Homework help',
      href: 'homework-help'
    }, {
      text: 'Exam prep',
      href: 'prep-for-an-exam'
    }, {
      text: 'Understand a topic',
      href: 'understand-a-topic'
    }, {
      text: 'Writing & citations',
      href: 'writing'
    }]
  }, {
    parent: {
      text: 'Tools'
    },
    children: [{
      text: 'Expert Q&A',
      href: 'study/qa'
    }, {
      text: 'Textbook Solutions',
      href: 'study/tbs'
    }, {
      text: 'Math Solver',
      href: 'math-solver'
    }, {
      text: 'Citations',
      href: 'writing/features/citation-generator'
    }, {
      text: 'Plagiarism checker',
      href: 'writing/features/plagiarism-checker'
    }, {
      text: 'Grammar checker',
      href: 'writing/features/grammar-check'
    }, {
      text: 'Expert proofreading',
      href: 'writing/features/proofreading'
    }]
  }]
}; // NavItem for career

export var careerNavItem = {
  parent: {
    text: 'Career',
    href: 'career'
  },
  children: [{
    text: 'Bootcamps',
    href: 'https://www.thinkful.com',
    useAbsolute: true,
    target: '_blank'
  }, {
    text: 'Internships',
    href: 'https://www.internships.com/',
    useAbsolute: true,
    target: '_blank'
  }, {
    text: 'Career advice',
    href: 'advice/career-center/'
  }]
};
export var lifeNavItem = {
  text: 'Life',
  href: 'introducing-chegg-life'
};
export var navLinks = [booksNavItem, studyNavItem, careerNavItem, lifeNavItem];
export default navLinks;